package org.hs_soft.runmynesto.pages.home.sub_page.product

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import com.varabyte.kobweb.compose.css.ScrollBehavior
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.scrollBehavior
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.pages.components.LoadingProgress
import org.hs_soft.runmynesto.pages.home.sub_page.product.component.GridProductBar
import org.hs_soft.runmynesto.pages.home.sub_page.product.component.ProductContent
import org.hs_soft.runmynesto.pages.home.sub_page.product.component.ProductDialogs
import org.hs_soft.runmynesto.pages.home.sub_page.product.mvi.ProductEvent
import org.hs_soft.runmynesto.pages.home.sub_page.product.mvi.ProductViewModel

@Composable
fun Product(
    modifier: Modifier = Modifier,
    windowSizeMode: WindowSizeModeEnum,
    viewModel: ProductViewModel,
){

    val state by viewModel.state.collectAsState()

    LaunchedEffect(viewModel){
        viewModel.onEvent(ProductEvent.GetProductsCategoryList)
        viewModel.onEvent(ProductEvent.GetCompanyProfileId)
        viewModel.onEvent(ProductEvent.GetCheckoutData)
        viewModel.onEvent(ProductEvent.GetPriceLevels)
        viewModel.onEvent(ProductEvent.GetPrinterLocationNames)
    }

    Column(
        modifier = modifier
            .scrollBehavior(ScrollBehavior.Smooth)
            .fillMaxSize()
    )
    {

        Row(
            modifier = Modifier
                .margin(top = Dimen.smallPadding)
                .fillMaxHeight()
                .fillMaxWidth(),
                horizontalArrangement =
                    if (windowSizeMode== WindowSizeModeEnum.PHONE)
                        Arrangement.Center
                    else Arrangement.Start
        )
        {
            if (state.firstPageActive) {
                GridProductBar(
                    windowSizeMode=windowSizeMode,
                    selectedItem = state.selectedProduct,
                    searchValue = state.mainGridSearchValue,
                    infoList = state.productsInfo,
                    loading=false,//state.productCategoryListLoading,
                    titleDescending = state.isMainGridNameSortedAsc,
                    numberDescending = state.isMainGridNumberSortedAsc,
                    showNumberSortIcon = state.showMainGridNumberSortIcon,
                    showTitleSortIcon = state.showMainGridNameSortIcon,
                    showFilterComponent = state.showProductItemsFilterComponent,
                    selectedFilterOption=state.selectedProductFilterItemsType,
                    onSearchValueChange = {
                        viewModel.onEvent(ProductEvent.OnSearchProductInputChange(it))
                    },
                    onProductClick = { id ->
                        viewModel.onEvent(
                            ProductEvent.OnProductItemClick(
                                id = id,
                                switchTheSecondPage = {
                                    if (windowSizeMode == WindowSizeModeEnum.PHONE)
                                        viewModel.onEvent(ProductEvent.OnChangePageClick)
                                }
                            )
                        )
                    },
                    onAddRecord = {
                        viewModel.onEvent(ProductEvent.OnAddRecordIconClick)
                    },
                    onTitleSortClick = {
                        viewModel.onEvent(ProductEvent.OnMainGridTitleSortClick)
                    },
                    onNumberSortClick = {
                        viewModel.onEvent(ProductEvent.OnMainGridNumberSortClick)
                    },
                    refreshList = {
                        viewModel.onEvent(ProductEvent.RefreshProductsCategoryList)
                    },
                    onFilterComponentClick = {
                        viewModel.onEvent(
                            ProductEvent.SetFilterProductItemsComponentStatus(
                            !state.showProductItemsFilterComponent)
                        )
                    },
                    onCloseFilterClick = {
                        viewModel.onEvent(ProductEvent.
                            SetFilterProductItemsComponentStatus(false))
                    },
                    selectFilterType = {
                        viewModel.onEvent(ProductEvent.SelectProductFilterType(it))
                    },
                    submitFilterItems = {
                        viewModel.onEvent(ProductEvent.SubmitFilterProductItems)
                    }
                )

                if (windowSizeMode != WindowSizeModeEnum.PHONE) {
                    ProductContent(
                        modifier = modifier.weight(1f),
                        windowSizeMode = windowSizeMode,
                        state = state,
                        onEvent = viewModel::onEvent,
                    )
                }

            } else {
                ProductContent(
                    modifier = modifier.weight(1f),
                    windowSizeMode = windowSizeMode,
                    state = state,
                    onEvent = viewModel::onEvent,
                )
            }

        }



    }

    LoadingProgress(
        visibility = state.generalDataLoading
    )

    ProductDialogs(
        state=state,
        windowSizeMode=windowSizeMode,
        event=viewModel::onEvent
    )


}

